import { CloudArrowUpIcon, LockClosedIcon, ServerIcon } from '@heroicons/react/20/solid'
import Table from "../../assets/table.jpg"

export default function PersonalAccident() {
  return (
    <div className="relative isolate overflow-hidden bg-white px-6 py-24 sm:py-32 lg:overflow-visible lg:px-0">
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <svg
          className="absolute left-[max(50%,25rem)] top-0 h-[64rem] w-[128rem] -translate-x-1/2 stroke-gray-200 [mask-image:radial-gradient(64rem_64rem_at_top,white,transparent)]"
          aria-hidden="true"
        >
          <defs>
            <pattern
              id="e813992c-7d03-4cc4-a2bd-151760b470a0"
              width={200}
              height={200}
              x="50%"
              y={-1}
              patternUnits="userSpaceOnUse"
            >
              <path d="M100 200V.5M.5 .5H200" fill="none" />
            </pattern>
          </defs>
          <svg x="50%" y={-1} className="overflow-visible fill-gray-50">
            <path
              d="M-100.5 0h201v201h-201Z M699.5 0h201v201h-201Z M499.5 400h201v201h-201Z M-300.5 600h201v201h-201Z"
              strokeWidth={0}
            />
          </svg>
          <rect width="100%" height="100%" strokeWidth={0} fill="url(#e813992c-7d03-4cc4-a2bd-151760b470a0)" />
        </svg>
      </div>
      <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start lg:gap-y-10">
        <div className="lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className="lg:max-w-lg">
              <p className="text-base font-semibold leading-7 text-indigo-600">Protect Who You Love</p>
              <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Personal Accident Insurance</h1>
              <p className="mt-6 text-xl leading-8 text-gray-700">
              Personal Accident insurance  is an annual policy which provides compensation in the event of injuries, disability or death caused solely by violent, accidental, external and visible events.
              </p>
            </div>
          </div>
        </div>
        <div className="-ml-12 -mt-12 p-12 lg:sticky lg:top-4 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:overflow-hidden">
          <img
            className="w-[48rem] max-w-none rounded-xl bg-gray-900 shadow-xl ring-1 ring-gray-400/10 sm:w-[57rem]"
            src={Table}
            alt=""
          />
        </div>
        <div className="lg:col-span-2 lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className="max-w-xl text-base leading-7 text-gray-700 lg:max-w-lg">
            
            <div className="my-4">
                <p><b>The benefits include:</b></p>
      <ul className="list-disc list-inside">
      <li>Weekly payment – Pays a weekly income for the period you are out of work as a result of injury from an accident.</li>
        <li>Medical Expenses - Pays for medical expenses that arise from treating you after an accident including dental and optical expenses.</li>
        <li>Emergency Evacuation – Covers emergency medical evacuation expenses.</li>
        <li>Pay for the cost of artificial appliances that arise from an accident such as crutches, hearing aid and prosthetics.</li>
        <li>Permanent Disability – in the event of permanent disability caused by an accident, the insurance pays for a pre-determined percentage of the insured amount or a pre-determined multiple of salary.</li>
        <li>Accidental Death – In the event that life is lost due to an accident, the insurance will pay the total insured amount or a pre-determined multiple of salary</li>
        </ul>
        </div>
             
              <h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">Who needs it?</h2>
              <p className="mt-6">
              Personal accident policy works as a supplement to life and Health insurance covers. To protect you and your family in the event of an accident that renders you unable to generate income or worse, causes your death. This is why it’s a good idea to have PA and health and life insurance – to cover your loved ones no matter what happens.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
